import React, { lazy, Suspense } from 'react'
import LoadingBackdrop from '../../shared/components/LoadingBackdrop/LoadingBackdrop'

const UserSettingsView = lazy(() => import('./UserSettingsView'))

const UserSettingsViewAsync = () => (
    <Suspense fallback={<LoadingBackdrop loading title="Settings" subtitle="Preparing Environment" />}>
        <UserSettingsView />
    </Suspense>
)

export default UserSettingsViewAsync
